module.exports = __webpack_public_path__ + "img/hello.bcd5425d.svg";